// extracted by mini-css-extract-plugin
export default {"adminLoginAsUserPopupContent":"AdminLoginAsUserPopup_adminLoginAsUserPopupContent__6DAGJ","userInfo":"AdminLoginAsUserPopup_userInfo__05gsi"};